export default {
	unifi_integration: {
		site_preparation: {
			steps: {
				unknown: 'Unknown step',
				purgeWirelessNetworks: 'Purge existing WiFi SSIDs',
				purgeNetworks: 'Purge existing VLANs',
				purgeFixedIps: 'Purge existing fixed IPs',
				resetAccessPointConfigurations: 'Reset custom AP configurations',
				enableWanDhcp: 'Set existing routers to use DHCP on WAN',
				setDefaultVlans: 'Set default VLANs',
				setFixedIps: 'Set fixed IPs',
				ensureDefaultSsidExists: 'Ensure the default WiFi SSID exists',
			},
		},
		device_move: {
			in_site: 'in site',
			last_seen: 'Last seen: {date} ({days} days, {hours} hours ago)',
			last_seen_unknown: 'Last seen: unknown',
			move_to_site: 'Move to site',
			select_site: 'Select a site ...',
			move_device: 'Move device',
			moved_message: '{device} moved from site {from} to site {to}',
			blocked_reason:
				'This device is not in the Default site (currently "{site}") and can therefore not be moved.',
			override_reasons: {
				long_offline: 'This device has been offline for a long time and can therefore be moved anyway.',
				unknown_last_seen: 'This device has no known last seen date and can therefore be moved anyway.',
			},
			confirm: {
				title: 'Move device?',
				body: 'Are you sure you want to move device "{device}" to site "{site}"?',
			},
			toasts: {
				moved: {
					title: 'Device moved',
					body: 'Device "{device}" was moved to site "{site}"',
				},
				move_failed: {
					title: 'Failed to move device',
					body: 'Device "{device}" could not be moved',
				},
			},
		},
	},
};
